export enum MuslimHubRoutePath {
    Registration = '/muslim-hub/registration',
    RegistrationVerification = '/muslim-hub/registration/verification/:id',
    ActivityApproval = '/muslim-hub/activity-approval',
    ApprovalVerification = '/muslim-hub/activity-approval/verification/:id',
    AreaApproval = '/muslim-hub/area-approval',
    AreaApprovalVerification = '/muslim-hub/area-approval/verification/:id',
    CreatorManagement = '/muslim-hub/creator-management',
    CreatorDetail = '/muslim-hub/creator-management/detail/:id',
    CreatorDetailProfile = '/muslim-hub/creator-management/detail/:id/profile',
    CreatorDetailAgenda = '/muslim-hub/creator-management/detail/:id/agenda/:idAgenda',
    CreatorDetailRating = '/muslim-hub/creator-management/detail/:id/agenda/:idAgenda/rating',
    CreatorDetailPlace = '/muslim-hub/creator-management/detail/:id/place/:idPlace'
}
